
import Button from "components/Button/Button";
import Text from "components/Text/Text";
import { ReactComponent as TriangleIcon } from "assets/triangle.svg";
import { ReactComponent as ExpandIcon } from "assets/expand.svg";
import styles from './Summary.module.scss';
import { Tab } from "Modules/PractitionerBaseballCard";
import useExternalApiService from '../../../../helpers/ExternalApiService';
import React from "react";
import { formatMoney, formatMoneyWithZero } from "helpers";
import { store } from "stores/Store";
interface ISummary {
  navigate: (path: Tab) => void;
}



const Summary = ({navigate}: ISummary) => {

  const apiUrl = process.env.REACT_APP_EAI_URL;
  const {postData} = useExternalApiService(apiUrl);
  const [keystats, setKeystats] = React.useState<any>(null);

  // 2) Pull out the practitioner properties
  const practitionerName = store.currentPractitioner?.primary_name;
  const dataSource = store.currentPractitioner?.data_source;
  const status = store.currentPractitioner?.status;

  const shouldShowWarning =
    dataSource === "PRACTITIONER_ACCOUNT_VIEW_NM" ||
    status === "LEAD-INCOMPLETE" ||
    status === "LEAD-READY2SUBMIT";

  React.useEffect(() => {
    if (!practitionerName) return;

    const getKeystats = async () => {
      const response = await postData('/api/e/call_winback_keystats_by_practitioner_name', {practitioner_name: store.currentPractitioner?.primary_name ?? ''});
      console.log(response.payload);
      setKeystats(response.payload);
    }
    getKeystats();
  }, [practitionerName]);

  // ── 2) Check warning conditions (data_source or status) ──────────────────────
  //
  // The three cases where we want to show a “warning” screen instead of Key Stats:
  //  • data_source === "PRACTITIONER_ACCOUNT_VIEW_NM"
  //  • status === "LEAD-INCOMPLETE"
  //  • status === "LEAD-READY2SUBMIT"
  //
  
  if (shouldShowWarning) {
    return (
      <div className={styles["summary-warning-container"]}>
        <p className={styles["summary-warning-text"]}>
          To view sales summary, this practitioner's baseball card needs to be matched in Netsuite to pull sales data.
        </p>
      </div>
    );
  }

  return(
    <>
     {/*
      <div className={styles.sectionWrapper}>
        <p className={styles.headerText}>NEXT STEPS</p>
      </div>
        <div className={styles.horizontalScrollItemWrapper}>
          <Button type="outline">FOLLOW UP</Button>
        </div>
        <div className={styles.horizontalScrollItemWrapper}>
          <Button type="outline">xxxxxxx</Button>
        </div>
        <div className={styles.horizontalScrollItemWrapper}>
          <Button type="outline">xxxxxxx</Button>
        </div>
        
      </div>
      */}
      {/* <div className={styles.sectionWrapper} onClick={() => navigate(Tab.OPPORTUNITIES)}>
        <p className={styles.headerText}>OPPORTUNITIES<ExpandIcon /></p>
      </div>
      <div className={styles.rowWrapper}>
        <div className={styles.columnWrapper}>
          <p className={styles.HugeText}>$56K</p>
          <Text>Opportunity by March 20</Text>
        </div>
        <div className={styles.columnWrapper}>
          <Text bold>1. GI Revive: 56 units</Text>
          <Text bold>2. CoQnol: 30 units</Text>
          <Text bold>3. Spotlight: 30 units</Text>
        </div>
      </div> */}
      <div className={styles.sectionWrapper} onClick={() => navigate(Tab.SUMMARY)}>
        <p className={styles.headerText}>KEY STATS{/*<ExpandIcon />*/}</p>
      </div>
      <div className={styles.twoColumnWrapper}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row' }}>
          {/*<p style={{ color: keystats?.mtd_diff < 0 ? '#E64B37' : '#00DC49CC', fontSize: '20px', fontWeight: '500', paddingRight: '10px' }}>{formatMoneyWithZero(keystats?.mtd_sales)}</p>*/}
          <p style={{fontSize: '20px', fontWeight: '500', paddingRight: '10px' }}>{formatMoneyWithZero(keystats?.mtd_sales)}</p>
          {/* {
            keystats?.mtd_diff < 0 ? (
              <TriangleIcon width="20px" height="20px" fill="#E64B37" />
            ) : (
              <TriangleIcon width="20px" height="20px" fill="#00DC49CC" style={{ transform: 'rotate(180deg)' }} />
            )
          } */}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row' }}>
          {/*<p style={{ color: keystats?.ytd_diff < 0 ? '#E64B37' : '#00DC49CC', fontSize: '20px', fontWeight: '500', paddingRight: '10px' }}>{formatMoneyWithZero(keystats?.ytd_sales)}</p>*/}
          <p style={{ fontSize: '20px', fontWeight: '500', paddingRight: '10px' }}>{formatMoneyWithZero(keystats?.ytd_sales)}</p>
          {/* {
            keystats?.ytd_diff < 0 ? (
              <TriangleIcon width="20px" height="20px" fill="#E64B37" />
            ) : (
              <TriangleIcon width="20px" height="20px" fill="#00DC49CC" style={{ transform: 'rotate(180deg)' }} />
            )
          } */}

        </div>
        <Text textAlign="center" bold>MTD Sales</Text>
        <Text textAlign="center" bold>YTD Sales</Text>
      </div>
      {/* <div className={styles.twoColumnWrapper}>
        <p className={styles.ordersText}>15</p>
        <p className={styles.HugeText}>XXX</p>
        <Text textAlign="center" bold>Open Orders</Text>
        <Text textAlign="center" bold>YYY Metric</Text>
      </div> */}
    </>
  )
}

export default Summary;